import { ProductVariantTable } from "~/features/productDetails/components/DataTables/ProductVariantTable";
import { CharacteristicsIcons } from "~/features/productDetails/components/DataTables/CharacteristicsIcons";
import { Card } from "~/features/configurator/Linear/components/Card";
import PdfDownloadLink from "~/features/productDetails/components/SpecificationsCard/components/PdfDownloadLink";
import { type PdpPageProductData } from "~/features/productDetails/models/PdpPageProductData";
import { Col, Row } from "~/common/components/Layout";
import BearingXPdfDownloadLink from "~/features/productDetails/components/SpecificationsCard/components/BearingXPdfDownloadLink";
import useMediaQuery from "~/common/hooks/useMediaQuery";
import RohsPdfDownloadLink from "~/features/productDetails/components/SpecificationsCard/components/RohsPdfDownloadLink";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "~/common/utils/screenSizes";
import { useTranslation } from "react-i18next";
import { useMemo, useState } from "react";
import { fetchBearingXId } from "~/features/productDetails/components/SpecificationsCard/api/fetchBearingXId";

interface Props {
  product: PdpPageProductData;
}

const VALID_CLASS_FOR_FREQUENCIES = "IDO_CATALOGUE_BEARING";

export const SpecificationsCard = ({ product }: Props) => {
  const [isReady, setIsReady] = useState(false);
  const [bearingXId, setBearingXId] = useState("");
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);
  const { t } = useTranslation();

  useMemo(() => {
    (async () => {
      if (product.showBasicFrequencies && product.bearingXDesignation) {
        const data = await fetchBearingXId(product.bearingXDesignation);
        if (data?.productInfo?.bearinxClass === VALID_CLASS_FOR_FREQUENCIES) {
          setBearingXId(data.productInfo.id);
        }
        setIsReady(true);
      } else {
        setIsReady(true);
      }
    })();
  }, [product.bearingXDesignation, product.showBasicFrequencies]);

  return (
    <>
      {isReady && (
        <Card className={"scha__pdp__specifications-card"} disableHover={true}>
          <Row>
            <Col size={12} className={"scha__pdp__download-title"}>
              {t("productDetailPage.downloads.title")}
            </Col>
            <Col size={12} className={isDesktop ? "pt-2" : ""}>
              <PdfDownloadLink product={product} />
            </Col>
            {product.showBasicFrequencies && !!bearingXId && (
              <Col size={12} className={isDesktop ? "pt-2" : ""}>
                <BearingXPdfDownloadLink product={product} bearingXId={bearingXId} />
              </Col>
            )}
            {product.showRohsDownload && (
              <Col size={12} className={isDesktop ? "pt-2" : ""}>
                <RohsPdfDownloadLink product={product} />
              </Col>
            )}
          </Row>
          {product.specificationBand && product.specificationBand.length > 0 && (
            <ProductVariantTable data={product.specificationBand} />
          )}
          {product.attributeIcons && product.attributeIcons.length > 0 && (
            <CharacteristicsIcons data={product.attributeIcons} />
          )}
        </Card>
      )}
    </>
  );
};
